export default "__VITE_ASSET__BlGXD$K3__"